<template>
  <nav
    class="
      navbar navbar-main navbar-expand-lg
      border-radius-xl
    "
    id="navbarBlur"
    data-scroll="true"
  >
    <NavbarContainer />
  </nav>
</template>

<script>
import { NavbarContainer } from "./exporter.js";
export default {
  name: "navbar-navigation-container",
  components: {
    NavbarContainer,
  },
};
</script>
